import { render, staticRenderFns } from "./UserHealthcare.vue?vue&type=template&id=e59868f2"
import script from "./UserHealthcare.vue?vue&type=script&lang=js"
export * from "./UserHealthcare.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports